import React from 'react'
import '../../css/Layout.css'
import Header from './Header'
import NavBar from './Navbar'
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './../../theme'
import Footer from '../global/footer/footer'
import Headroom from 'react-headroom'


const Layout = ({ children }) => {
    return (
        <ThemeProvider theme={theme}>         
            <Headroom>
                <Header />
                <NavBar />
            </Headroom>
            {children}
            <Footer />
        </ThemeProvider>
    )
}

export default Layout
